interface Team {
  nickName?: string;
  name?: string;
}

interface Game {
  id: string;
  statusDesc: string;
  awayTeam: Team;
  homeTeam: Team;
}

interface Video {
  properties: {
    gameId?: string;
  };
}

interface Row {
  data?: Video[];
}

export const isGameFinal = (game: Game): boolean => {
  return game.statusDesc === 'FINAL';
};

export const teamNamesExist = (game: Game): boolean => {
  return !!(
    (game.awayTeam.nickName || game.awayTeam.name) &&
    (game.homeTeam.nickName || game.homeTeam.name)
  );
};

export const shouldDisplayTile = (game: Game | null): boolean => {
  return !!game && isGameFinal(game) && !!teamNamesExist(game);
};

export const getHighlightsRowData = (row: Row, games: Game[] | null): Video[] => {
  if (!row.data) return [];
  return row.data.filter(item =>
    shouldDisplayTile(getGamebyVideo(item, games)),
  );
};

export const getGamebyVideo = (video: Video, games: Game[] | null): Game | null => {
  let game = null;
  const { gameId } = video.properties;
  if (gameId != null && games != null) {
    game = games.find(i => i.id === gameId);
  }
  return game;
};
